/**
 * "Email me this plan" — client call to POST /api/checkout/email-plan
 * (server/cart-recovery.js). Signed-in customers are identified by their JWT;
 * signed-out ones prove ownership with the booking-flow session id.
 */
import { supabase } from '@/lib/supabase';

export async function requestPlanEmail({ cartId, sessionId, email, snapshot }) {
  const { data: { session } } = await supabase.auth.getSession();
  const headers = { 'Content-Type': 'application/json' };
  if (session?.access_token) headers.Authorization = `Bearer ${session.access_token}`;
  const res = await fetch('/api/checkout/email-plan', {
    method: 'POST',
    headers,
    body: JSON.stringify({ cartId, sessionId, email: email || undefined, snapshot }),
  });
  const body = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(body?.error || 'Could not send the email');
  return body;
}
